import React from 'react';
import { BackgroundImg } from 'elements/util';
import { StyledBanner } from './styled';

class Banner extends React.PureComponent {
  render() {
    const { data: { image } } = this.props;
    return (
      <StyledBanner role="banner">
        <BackgroundImg src={(process.env.PUBLIC_URL || '') + image} />
      </StyledBanner>
    );
  }
};

export default Banner;



// WEBPACK FOOTER //
// ./src/pages/Kategorija/components/Banner/Banner.jsx